import type { SxProps, Theme } from '@mui/material/styles'

const separatorPseudoElementSx = (selector: string): SxProps<Theme> => ({
  [`& ${selector}:not(:last-child)::after`]: {
    content: '""',
    position: 'absolute',
    left: '16px',
    bottom: 0,
    height: '0.5px',
    width: 'calc(100% - 32px)',
    backgroundColor: 'border.subtle',
  },
})

export const listSeparatorSx = separatorPseudoElementSx('.MuiButtonBase-root')

export const radioListSeparatorSx = separatorPseudoElementSx(
  '.MuiButtonBase-root',
)

export const getListItemBorderSx = (
  borderVariant?: 'default' | 'fullWidth',
): SxProps<Theme> => ({
  borderBottom: '1px solid',
  borderColor: 'border.subtle',
  mx: borderVariant === 'fullWidth' ? 0 : 2,
})
